import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { DSelectFormControl } from "../../entities/form-control";
import { FormField } from "../../entities/form-field";

@Component({
	selector: "form-text",
	template: `
		<div class="dynamic-field form-text" [formGroup]="group">
			<label>
				<ng-content select="h3" />

				Select
			</label>
		</div>
	`,
	styleUrls: ["form-select.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormSelectComponent implements FormField {
	@Input() config: DSelectFormControl;
	@Input() group: UntypedFormGroup;

	get placeholder() {
		return this.config.placeholder || "";
	}
}
